import styled from "styled-components";
import { Link } from "react-router-dom";

export const PageOuter = styled.div`
  max-width: 1100px;
  width: 100%;
  margin: 40px auto 60px;
  padding: 0 var(--container-pad);

  @media (max-width: 600px) {
    margin: 24px auto 40px;
  }
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const BackLink = styled(Link)`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-muted);
  text-decoration: none;
  padding: 8px 14px;
  border-radius: 999px;
  background: var(--color-bg-soft);
  transition: var(--transition);

  svg {
    width: 12px;
    height: 10px;
  }

  &:hover {
    color: var(--color-primary);
    background: var(--color-primary-soft);
  }
`;

export const HeroBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  border-radius: 999px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: var(--color-text);
  max-width: 900px;
`;

export const Accent = styled.div`
  width: 56px;
  height: 4px;
  background: var(--color-primary);
  border-radius: 999px;
`;

export const SliderBlock = styled.div`
  width: 100%;
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-lg);

  .swiper {
    border-radius: var(--radius-xl);
  }

  .swiper-pagination-bullet {
    background: white;
    opacity: 0.7;
  }

  .swiper-pagination-bullet-active {
    background: var(--color-primary);
    opacity: 1;
    width: 22px;
    border-radius: 999px;
  }
`;

export const SliderImg = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;

  @media (max-width: 600px) {
    aspect-ratio: 4 / 3;
  }
`;

export const ContentCard = styled.article`
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: 44px 52px;
  box-shadow: var(--shadow-sm);

  @media (max-width: 768px) {
    padding: 28px 22px;
  }
`;

export const LeadParagraph = styled.p`
  font-size: 19px;
  font-weight: 500;
  line-height: 1.65;
  color: var(--color-text);
  margin: 0 0 24px;
  padding-left: 16px;
  border-left: 3px solid var(--color-primary);

  @media (max-width: 600px) {
    font-size: 17px;
    padding-left: 12px;
  }
`;

export const Paragraph = styled.p`
  font-size: 17px;
  font-weight: 400;
  line-height: 1.75;
  color: var(--color-text);
  margin: 0 0 18px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Quote = styled.blockquote`
  margin: 22px 0;
  padding: 16px 22px;
  background: var(--color-bg-soft);
  border-left: 4px solid var(--color-primary);
  border-radius: var(--radius-md);
  font-size: 17px;
  font-style: italic;
  font-weight: 500;
  line-height: 1.6;
  color: var(--color-text);
`;

export const BulletList = styled.ul`
  list-style: none;
  margin: 12px 0 22px;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 24px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BulletItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 16px;
  line-height: 1.5;
  color: var(--color-text);

  &::before {
    content: "";
    flex-shrink: 0;
    width: 7px;
    height: 7px;
    margin-top: 8px;
    background: var(--color-primary);
    border-radius: 50%;
  }
`;

export const NotFoundBlock = styled.div`
  text-align: center;
  padding: 80px 20px;
  color: var(--color-text-muted);
  font-size: 18px;
`;
